import styled from 'styled-components'

export const DataContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1.5rem;

  p {
    margin: 0;
    padding: 0;

    span {
      font-weight: 500;
    }
  }

  div {
    display: flex;
    gap: 1rem;
  }
`
